// Hand-maintained Stimulus manifest (#1716).
//
// Identifiers are short kebab-case (e.g. "choices", "purchase-form") unless a
// view already uses a namespaced id (e.g. "shared--nav"). Do NOT run
// `bin/rails stimulus:manifest:update` — it overwrites short names with
// folder-prefixed ids. CI: bin/check-stimulus-wiring

import { application } from "./application"

// --- Jobs ---
import JobTransactionsPanelController from "./jobs/job_transactions_panel_controller.js"
application.register("job-transactions-panel", JobTransactionsPanelController)

import PurchaseFormController from "./jobs/purchase_form_controller.js"
application.register("purchase-form", PurchaseFormController)

import StripeCheckoutController from "./jobs/stripe_checkout_controller.js"
application.register("stripe-checkout", StripeCheckoutController)

import JobAnnouncementFormController from "./jobs/job_announcement_form_controller.js"
application.register("job-announcement-form", JobAnnouncementFormController)

import LeadJobModalController from "./jobs/lead_job_modal_controller.js"
application.register("lead-job-modal", LeadJobModalController)

import Jobs__ActivityChartController from "./jobs/activity_chart_controller.js"
application.register("jobs--activity-chart", Jobs__ActivityChartController)

import Jobs__ViewMapController from "./jobs/view_map_controller.js"
application.register("jobs--view-map", Jobs__ViewMapController)

// --- Components (short) ---
import ButtonController from "./components/button_controller.js"
application.register("button", ButtonController)

import CardSelectorController from "./components/card_selector_controller.js"
application.register("card-selector", CardSelectorController)

import DropdownController from "./components/dropdown_controller.js"
application.register("dropdown", DropdownController)

import ImagePreviewController from "./components/image_preview_controller.js"
application.register("image-preview", ImagePreviewController)

import LottieController from "./components/lottie_controller.js"
application.register("lottie", LottieController)

import ModalController from "./components/modal_controller.js"
application.register("modal", ModalController)

import ModalTriggerController from "./components/modal_trigger_controller.js"
application.register("modal-trigger", ModalTriggerController)

import TippyController from "./components/tippy_controller.js"
application.register("tippy", TippyController)

import TrixController from "./components/trix_controller.js"
application.register("trix", TrixController)

// --- Components (namespaced — used in ERB) ---
import Components__CheckboxToggleController from "./components/checkbox_toggle_controller.js"
application.register("components--checkbox-toggle", Components__CheckboxToggleController)

import Components__ConfettiController from "./components/confetti_controller.js"
application.register("components--confetti", Components__ConfettiController)

import Components__InputCheckboxToggleController from "./components/input_checkbox_toggle_controller.js"
application.register("components--input-checkbox-toggle", Components__InputCheckboxToggleController)

import Components__RadiosSwitchController from "./components/radios_switch_controller.js"
application.register("components--radios-switch", Components__RadiosSwitchController)

import Components__SelectJumperController from "./components/select_jumper_controller.js"
application.register("components--select-jumper", Components__SelectJumperController)

import SheetController from "./components/sheet_controller.js"
application.register("sheet", SheetController)

import Components__SelectSwitchController from "./components/select_switch_controller.js"
application.register("components--select-switch", Components__SelectSwitchController)

import Components__StickyController from "./components/sticky_controller.js"
application.register("components--sticky", Components__StickyController)

import Components__TabsController from "./components/tabs_controller.js"
application.register("components--tabs", Components__TabsController)

// --- Forms (short) ---
import ActiveStorageCompactController from "./forms/active_storage_compact_controller.js"
application.register("active-storage-compact", ActiveStorageCompactController)

import ActiveStorageDropzoneController from "./forms/active_storage_dropzone_controller.js"
application.register("active-storage-dropzone", ActiveStorageDropzoneController)

import ActiveStorageMultipleController from "./forms/active_storage_multiple_controller.js"
application.register("active-storage-multiple", ActiveStorageMultipleController)

import AutoSubmitFormController from "./forms/auto_submit_form_controller.js"
application.register("auto-submit-form", AutoSubmitFormController)

import CheckboxDisableControlsController from "./forms/checkbox_disable_controls_controller.js"
application.register("checkbox-disable-controls", CheckboxDisableControlsController)

import ChoicesController from "./forms/choices_controller.js"
application.register("choices", ChoicesController)

import CollapsibleController from "./forms/collapsible_controller.js"
application.register("collapsible", CollapsibleController)

import InvitationFormController from "./forms/invitation_form_controller.js"
application.register("invitation-form", InvitationFormController)

import InvoiceProductCalculatorController from "./forms/invoice_product_calculator_controller.js"
application.register("invoice-product-calculator", InvoiceProductCalculatorController)

import LogoFetcherController from "./forms/logo_fetcher_controller.js"
application.register("logo-fetcher", LogoFetcherController)

import NestedLineListController from "./forms/nested_line_list_controller.js"
application.register("nested-line-list", NestedLineListController)

import PhoneNumberController from "./forms/phone_number_controller.js"
application.register("phone-number", PhoneNumberController)

import RecipientPickerController from "./forms/recipient_picker_controller.js"
application.register("recipient-picker", RecipientPickerController)

import TurnstileController from "./forms/turnstile_controller.js"
application.register("turnstile", TurnstileController)

// --- Forms (namespaced — used in ERB) ---
import Forms__DatetimeLocalController from "./forms/datetime_local_controller.js"
application.register("forms--datetime-local", Forms__DatetimeLocalController)

import Forms__JobLocationController from "./forms/job_location_controller.js"
application.register("forms--job-location", Forms__JobLocationController)

import Forms__JobContractAddController from "./forms/job_contract_add_controller.js"
application.register("forms--job-contract-add", Forms__JobContractAddController)

// --- Tables ---
import IndexSelectableController from "./tables/index_selectable_controller.js"
application.register("index-selectable", IndexSelectableController)

import SortableTableController from "./tables/sortable_table_controller.js"
application.register("sortable-table", SortableTableController)

// --- Shared (short) ---
import MapController from "./shared/map_controller.js"
application.register("map", MapController)

import NavUpgradeController from "./shared/nav_upgrade_controller.js"
application.register("nav-upgrade", NavUpgradeController)

import SearchController from "./shared/search_controller.js"
application.register("search", SearchController)

// --- Landing (namespaced) ---
import Landing__ActivityTickerController from "./landing/activity_ticker_controller.js"
application.register("landing--activity-ticker", Landing__ActivityTickerController)

import Landing__CountdownController from "./landing/countdown_controller.js"
application.register("landing--countdown", Landing__CountdownController)

import Landing__FloatingNavController from "./landing/floating_nav_controller.js"
application.register("landing--floating-nav", Landing__FloatingNavController)

import Landing__RecordRevealController from "./landing/record_reveal_controller.js"
application.register("landing--record-reveal", Landing__RecordRevealController)

import Shared__IntercomLaunchController from "./shared/intercom_launch_controller.js"
application.register("shared--intercom-launch", Shared__IntercomLaunchController)

import Landing__MarqueeController from "./landing/marquee_controller.js"
application.register("landing--marquee", Landing__MarqueeController)

import Shared__NavController from "./shared/nav_controller.js"
application.register("shared--nav", Shared__NavController)

import Shared__NavSwitcherController from "./shared/nav_switcher_controller.js"
application.register("shared--nav-switcher", Shared__NavSwitcherController)

import Landing__PlanholderFeedController from "./landing/planholder_feed_controller.js"
application.register("landing--planholder-feed", Landing__PlanholderFeedController)

import Landing__ProcessFlowController from "./landing/process_flow_controller.js"
application.register("landing--process-flow", Landing__ProcessFlowController)

import Landing__ProjectsMapController from "./landing/projects_map_controller.js"
application.register("landing--projects-map", Landing__ProjectsMapController)

import Landing__RecordStatsController from "./landing/record_stats_controller.js"
application.register("landing--record-stats", Landing__RecordStatsController)

import Landing__ScatterRevealController from "./landing/scatter_reveal_controller.js"
application.register("landing--scatter-reveal", Landing__ScatterRevealController)

// --- Page-specific (namespaced) ---
import Calendar__FullCalendarController from "./calendar/full_calendar_controller.js"
application.register("calendar--full-calendar", Calendar__FullCalendarController)

import Directories__ShowMapController from "./directories/show_map_controller.js"
application.register("directories--show-map", Directories__ShowMapController)

import Guides__PlayerController from "./guides/player_controller.js"
application.register("guides--player", Guides__PlayerController)

import Heartbeat__ChartsController from "./heartbeat/charts_controller.js"
application.register("heartbeat--charts", Heartbeat__ChartsController)

import JobFiles__ViewerController from "./job_files/viewer_controller.js"
application.register("job-files--viewer", JobFiles__ViewerController)
